module.exports = __webpack_public_path__ + "static/appIcon-d233827ca6f33a6e32b90470658bac16.svg";